"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.expandedSelector = expandedSelector;
exports.socialErrorSelector = socialErrorSelector;
var _social = require("../../types/social");
function socialErrorSelector(state) {
  const {
    status,
    errorType,
    error
  } = state.social.authenticate;
  const hasError = status === _social.EAuthenticateStatus.Failed && (!errorType || ![_social.EAuthenticateError.EmailRequired, _social.EAuthenticateError.EmailTaken].includes(errorType));
  return hasError && error || undefined;
}
function expandedSelector(state) {
  return state.social.expanded;
}